import g from '#core/global';
import load from '#core/load';

// Constants
const form_$ = '.signup-form form';
const message_class = 'signup-form__message';
const busy_attr = 'aria-busy';
const error_attr = 'data-is-error';

/*
 * Forms pointing at the WordPress ajax endpoint (e.g. the VoterVoice
 * subscribe listener) return a JSON envelope rather than a page, so
 * they are submitted via fetch and the response is shown inline.
 */
const ajax_endpoint_s = 'admin-ajax.php';
const fallback_error_s = 'Sorry, something went wrong. Please try again later.';

let has_form = false;

const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('signup-form')) return false;

		load.content(() => {
			has_form = assign_elements();
		});
	},

};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_form) return true;

	document.addEventListener(g.submit_e, e => {
		const $form = e.target.closest(form_$);
		if (!$form) return;
		if (!$form.action.includes(ajax_endpoint_s)) return;

		e.preventDefault();
		submit_form($form);
	});

	return true;
}


/**
 * Submit form data to the ajax endpoint
 * @param {element} $form
 */
function submit_form($form) {
	if ($form.getAttribute(busy_attr) === g.true_s) return false;
	$form.setAttribute(busy_attr, g.true_s);

	fetch($form.action, {
		method: 'POST',
		body: new FormData($form),
	})
		.then(response => response.json())
		.then(json => {
			const is_success = !!json.success;
			show_message($form, json.data?.message || fallback_error_s, is_success);
			if (is_success) $form.reset();
		})
		.catch(() => {
			show_message($form, fallback_error_s, false);
		})
		.finally(() => {
			$form.removeAttribute(busy_attr);
		});
}


/**
 * Show the response message below the form
 * @param {element} $form
 * @param {string} text
 * @param {boolean} is_success
 */
function show_message($form, text, is_success) {
	let $message = $form.querySelector(`.${message_class}`);

	if (!$message) {
		$message = document.createElement('p');
		$message.className = message_class;
		$message.setAttribute('role', 'status');
		$form.appendChild($message);
	}

	$message.setAttribute(error_attr, is_success ? g.false_s : g.true_s);
	$message.textContent = text;
}
